import classNames from 'classnames';
import React from 'react';

interface Props {
  visible: boolean;
  className?: string;
}

export const ValidationMessage: React.FC<React.PropsWithChildren<Props>> = ({
  visible,
  className,
  children,
  ...rest
}) => {
  return (
    <div
      className={classNames('text-left text-sm text-red-600', visible ? 'visible opacity-100' : 'hidden', className)}
      role="alert"
      {...rest}
    >
      {children}
    </div>
  );
};
